<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createMiniType" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.type_id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.type_name }}</td>
              <td align="center">
                <v-icon :color="item.marker_color">fas fa-circle</v-icon>
              </td>
              <td>
                <a @click="showMiniTypeData(item.type_id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "MiniTypeTable",
  components: {Paginate, InputSearch, CircleButton, IconPencil },
  data() {
    return {
      title: "TCDC Mini Type",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "type name" },
        { id: 3, text: "marker color" },
        { id: 4, text: "Edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getMiniTypeTable(1);
  },
  methods: {
    getMiniTypeTable(page) {
      this.$store.dispatch("MiniType/getMiniType", page).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    goToMiniTypeEdit() {
      this.$router.push("/tcdc-mini-type/edit");
    },
    showMiniTypeData(id) {
      this.$store.dispatch("MiniType/showMiniType", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("MiniType/setFormMiniType", res.result).then(() => {
            this.goToMiniTypeEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    createMiniType() {
      this.$store.dispatch("MiniType/clearFormData").then(() => {
        this.goToMiniTypeEdit();
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("MiniType/getMiniType", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
.branch-data {
  background-color: transparent;
  margin: 20px;
}
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
